export default __webpack_public_path__ + "static/media/IndividualTreatmentVisualisationStandard.955d72c4.svg";